import { render, staticRenderFns } from "./UserAvatarSettings.vue?vue&type=template&id=995450be&scoped=true"
import script from "./UserAvatarSettings.vue?vue&type=script&lang=js"
export * from "./UserAvatarSettings.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarSettings.vue?vue&type=style&index=0&id=995450be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995450be",
  null
  
)

export default component.exports